import { Map } from "immutable";

// Mixins
import {LayerMixin} from "@/mixins";

export default {
  style: LayerMixin.MAP_SATELLITE_STYLE_URL,
  center: {
    lng: "139.86448000000001",
    lat: "35.54817666666667",
  },
  zoom: 13,
  defaultPosition: {
    lat: "139.86448000000001",
    lng: "35.54817666666667",
    zoom: 13,
  },
  vessel_categories: Map({
    0: true, // 全て
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    7: true,
    8: true,
    9: true,
    10: true,
    11: true,
    12: true,
  }),
  plot_categories: Map({
    0: true, // 全て
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    8: true,
    9: true,
    10: true,
    12: true,
    13: true,
    15: true,
    16: true,
  })
}
